export const isTouch = 'ontouchstart' in document.documentElement;
